import { Link } from 'react-router-dom';

const Button = ({ className = "", to, text, icon_path, alt_text }) => {

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <Link className={className} onClick={scrollToTop} to={ to }>
      <div className="button">
        <h6>{ text }</h6>
        <img className="icon" src={ icon_path } alt={ alt_text } />
      </div>
    </Link>
      
  );
}

export default Button;